import type { RoleId } from '@parts/shared';
import { getAuth, useAuth } from './auth';

/** Роль вошедшего пользователя (назначает администратор). */
export function getRole(): RoleId {
  return getAuth().user?.role ?? 'sales';
}

export function useRole(): RoleId {
  return useAuth().user?.role ?? 'sales';
}
